var Shuffle = function(a) {
    var j, x, i;
    for (i = a.length; i; i -= 1) {
        j = Math.floor(Math.random() * i);
        x = a[i - 1];
        a[i - 1] = a[j];
        a[j] = x;
    }
    return a;
}

var Spin = function (input) {
    if (input == null) {
        return "";
    }
    var size = input.length;
    var originalChars = input.split("");
    var stack = [];
    for (var i = 0; i < size; i++) {
        stack.push("");
    }
    var n = 0;
    var count = 0;
    var max = 0;
    for (var i = 0; i < originalChars.length; i++) {
        if (originalChars[i] == '{') {
            count++;
            if (count > max) {
                max = count;
            }
        } else if (originalChars[i] == '}') {
            count--;
        }
    }
    var posOpen = [];
    var currentOpen = 0;

    for (var i = 0; i < originalChars.length; i++) {
        if (n > 0) {
            if (originalChars[i] == '}') {
                if (stack[n - 1] == '{') {
                    n--;
                    currentOpen--;
                    continue;
                } else if (stack[n - 1] == '|') {
                    n--;
                }
            } else if (originalChars[i] == '|') {
                if (stack[n - 1] == '|') {
                    continue;
                } else if (stack[n - 1] == '{') {
                    continue;
                }
            }
        }
        if (originalChars[i] != '}') {
            stack[n] = originalChars[i];
            n++;
            if (originalChars[i] == '{') {
                currentOpen++;
                posOpen[currentOpen - 1] = n - 1;
            }
        } else {
            if (currentOpen == 0) {
                stack[n] = originalChars[i];
                n++;
            } else {
                var slashCount = 0;
                for (var j = posOpen[currentOpen - 1] + 1; j < n; j++) {
                    if (stack[j] == '|') {
                        slashCount++;
                    }
                }
                if (posOpen[currentOpen - 1] > 0 && stack[posOpen[currentOpen - 1] - 1] == '~') {
                    var parts = [];
                    var builder = "";
                    var id = 0;
                    for (var j = posOpen[currentOpen - 1] + 1; j < n; j++) {
                        if (stack[j] == '|') {
                            parts.push(builder);
                            id++;
                            builder = "";
                        } else {
                            builder = builder + stack[j];
                        }
                    }
                    parts.push(builder);
                    n = posOpen[currentOpen - 1] - 1;
                    parts = Shuffle(parts);
                    for (var j = 0; j < parts.length; j++) {
                        var part = parts[j];
                        for (var k = 0; k < part.length; k++) {
                            stack[n] = part[k];
                            n++;
                        }
                    }
                    currentOpen--;
                } else {
                    var choice = Math.floor(Math.random() * (slashCount + 1));
                    var tmpSlashCount = 0;
                    var pos = posOpen[currentOpen - 1];
                    while (tmpSlashCount < choice) {
                        pos = pos + 1;
                        if (stack[pos] == '|') {
                            tmpSlashCount++;
                        }
                    }
                    pos = pos + 1;
                    var tmp = posOpen[currentOpen - 1];
                    if (pos < n && stack[pos] != '|') {
                        while (pos < n) {
                            stack[tmp] = stack[pos];
                            tmp++;
                            pos++;
                            if (pos >= n || stack[pos] == '|' || stack[pos] == '}' || stack[pos] == '{') {
                                break;
                            }
                        }
                    }
                    n = tmp;
                    currentOpen--;
                }
            }
        }

    }
    //console.log(n);
    var result = "";
    for (var i = 0; i < n; i++) {
        result = result + stack[i];
    }
    return result;
}

export { Spin };